import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { Auth, Storage } from 'aws-amplify';

@Component({
  selector: 'app-s3-image-preview',
  templateUrl: './s3-image-preview.component.html',
  styleUrls: ['./s3-image-preview.component.scss']
})
export class S3ImagePreviewComponent implements OnInit {

  @ViewChild('el') el:ElementRef
  @Input('key') key:string

  constructor() { }

  ngOnInit(): void {
    this.getUrl()
  }

  src:any
  async getUrl() {
    const src = await Storage.get(this.key, {customPrefix: {public: ''}})
    this.src = src
  }

}
